import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./zenta-image-picker.css";
import { ImageDetails } from "burde";

interface ZentaImagePickerProps {
    selectedImageId: number | null;
    onClick: (selectedImage: ImageDetails | null) => void;
    images: Array<ImageDetails>;
    borderPicker?: boolean;
    forceFitImage?: boolean;
    resizeImage?: boolean;
    removeMarginBottom?: boolean;
}

const ZentaImagePickerV3: React.FC<ZentaImagePickerProps> = ({
    selectedImageId,
    onClick,
    images,
    forceFitImage = false,
    removeMarginBottom = false,
}) => {
    const cx = cn.bind(styles);

    const isOwnerPage = window.location.pathname.includes("owner-page");

    const ulCn = () =>
        cx({
            imagePickerUl: true,
            noBottomMargin: removeMarginBottom,
        });

    const liCn = () =>
        cx({
            imagePickerLi: true,
        });

    const imageCn = (isSelected: boolean) =>
        cx({
            imageItem: true,
            imageItemCover: !isOwnerPage,
            imageItemSelected: isSelected,
            forceFitImage: forceFitImage,
            noBottomMargin: removeMarginBottom,
            ownerPage: isOwnerPage,
        });

    return (
        <ul className={ulCn()}>
            {images.map((image) => {
                return (
                    <li key={image.id} className={liCn()}>
                        <div
                            className={imageCn(
                                selectedImageId != null &&
                                    image.id === selectedImageId,
                            )}
                            style={{
                                backgroundImage: `url(${
                                    (image.endpoints.leftPage &&
                                        image.endpoints.leftPage.thumbnail) ||
                                    image.endpoints.thumbnail
                                })`,
                            }}
                            onClick={() =>
                                onClick(
                                    selectedImageId !== null &&
                                        image.id === selectedImageId
                                        ? null
                                        : image,
                                )
                            }
                        />
                    </li>
                );
            })}
        </ul>
    );
};

export default ZentaImagePickerV3;
